import * as types from './action-types';
import apiRequest from '../helpers/apiRequest';
import listOfUrls from '../helpers/alerts-tasks-urls';
import moment from 'moment';

export const pastDueNeedsReviewEvents = (userInfo, jwtToken) => {
    if (
        userInfo.Billet.location !== 'OSS' ||
        userInfo.Billet.location !== 'RSS'
    ) {
        return apiRequest(
            listOfUrls.pastDueNeedsReviewEvents(userInfo),
            jwtToken
        )
            .then(response => {
                const pastDueNeedsReviewEvents = response.data.map(item => {
                    return {
                        createdAt: item.createdAt,
                        id: item.Event.id,
                        links: item.Event.links[0].self,
                        updatedAt: item.updatedAt,
                        name: item.Event.name,
                        dueDate: moment(item.endDate)
                            .add(7, 'days')
                            .format('YYYY-MM-DD')
                    };
                });
                return Promise.resolve(pastDueNeedsReviewEvents);
            })
            .catch(err => Promise.reject(err));
    } else {
        return Promise.resolve([]);
    }
};

export const pastDueNeedsReviewAfterActions = (userInfo, jwtToken) => {
    if (
        userInfo.Billet.location !== 'OSS' ||
        userInfo.Billet.location !== 'RSS'
    ) {
        return apiRequest(
            listOfUrls.pastDueNeedsReviewAfterActions(userInfo),
            jwtToken
        )
            .then(response => {
                const pastDueNeedsReviewAfterActions = response.data.map(
                    item => {
                        return {
                            createdAt: item.createdAt,
                            id: item.EventReport.Event.id,
                            links: item.EventReport.Event.links[0].self,
                            name: item.EventReport.Event.name,
                            updatedAt: item.updatedAt,
                            dueDate: moment(item.EventReport.Event.endDate)
                                .add(7, 'days')
                                .format('YYYY-MM-DD')
                        };
                    }
                );
                return Promise.resolve(pastDueNeedsReviewAfterActions);
            })
            .catch(err => Promise.reject(err));
    } else {
        return Promise.resolve([]);
    }
};

export const pastDueReturnedForEditEvents = (userInfo, jwtToken) => {
    return apiRequest(
        listOfUrls.pastDueReturnedForEditEvents(userInfo),
        jwtToken
    )
        .then(response => {
            const pastDueReturnedForEditEvents = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.Event.id,
                    links: item.Event.links[0].self,
                    name: item.Event.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.Event.endDate)
                        .add(3, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(pastDueReturnedForEditEvents);
        })
        .catch(err => Promise.reject(err));
};

export const pastDueReturnedForEditAfterActions = (userInfo, jwtToken) => {
    return apiRequest(
        listOfUrls.pastDueReturnedForEditAfterActions(userInfo),
        jwtToken
    )
        .then(response => {
            const pastDueReturnedForEditAfterActions = response.data.map(
                item => {
                    return {
                        createdAt: item.createdAt,
                        id: item.EventReport.Event.id,
                        links: item.EventReport.Event.links[0].self,
                        name: item.EventReport.Event.name,
                        updatedAt: item.updatedAt,
                        dueDate: moment(item.EventReport.Event.endDate)
                            .add(3, 'days')
                            .format('YYYY-MM-DD')
                    };
                }
            );
            return Promise.resolve(pastDueReturnedForEditAfterActions);
        })
        .catch(err => Promise.reject(err));
};

export const pastDueIncompleteAfterAction = (userInfo, jwtToken) => {
    return apiRequest(
        listOfUrls.pastDueIncompleteAfterAction(userInfo),
        jwtToken
    )
        .then(response => {
            const pastDueIncompleteAfterAction = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.Event.id,
                    links: item.Event.links[0].self,
                    name: item.Event.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.Event.endDate)
                        .add(7, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(pastDueIncompleteAfterAction);
        })
        .catch(err => Promise.reject(err));
};

export const incompleteEvents = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.incompleteEvents(userInfo), jwtToken)
        .then(response => {
            const incompleteEvents = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    updatedAt: item.createdAt,
                    id: item.id,
                    links: item.links[0].self,
                    name: item.name,
                    dueDate: moment(item.endDate)
                        .add(7, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(incompleteEvents);
        })
        .catch(err => Promise.reject(err));
};

export const incompleteAfterActions = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.incompleteAfterActions(userInfo), jwtToken)
        .then(response => {
            const incompleteAfterActions = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    updatedAt: item.createdAt,
                    id: item.Event.id,
                    links: item.Event.links[0].self,
                    name: item.Event.name,
                    dueDate: moment(item.Event.endDate)
                        .add(7, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(incompleteAfterActions);
        })
        .catch(err => Promise.reject(err));
};

export const incompleteAssignedAfterActions = (userInfo, jwtToken) => {
    return apiRequest(
        listOfUrls.incompleteAssignedAfterActions(userInfo),
        jwtToken
    )
        .then(response => {
            const incompleteAssignedAfterActions = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.Event.id,
                    links: item.Event.links[0].self,
                    name: item.Event.name,
                    dueDate: moment(item.Event.endDate)
                        .add(7, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(incompleteAssignedAfterActions);
        })
        .catch(err => Promise.reject(err));
};

export const needsReviewEvents = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.needsReviewEvents(userInfo), jwtToken)
        .then(response => {
            const needsReviewEvents = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.Event.id,
                    links: item.Event.links[0].self,
                    updatedAt: item.updatedAt,
                    name: item.Event.name,
                    dueDate: moment(item.Event.endDate).format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(needsReviewEvents);
        })
        .catch(err => Promise.reject(err));
};

export const needsReviewAfterActions = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.needsReviewAfterActions(userInfo), jwtToken)
        .then(response => {
            const needsReviewAfterActions = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.EventReport.Event.id,
                    links: item.EventReport.Event.links[0].self,
                    name: item.EventReport.Event.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.EventReport.Event.endDate).format(
                        'YYYY-MM-DD'
                    )
                };
            });
            return Promise.resolve(needsReviewAfterActions);
        })
        .catch(err => Promise.reject(err));
};

export const pendingApprovalEvents = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.pendingApprovalEvents(userInfo), jwtToken)
        .then(response => {
            const pendingApprovalEvents = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.id,
                    links: item.links[0].self,
                    name: item.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.endDate)
                        .add(7, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(pendingApprovalEvents);
        })
        .catch(err => Promise.reject(err));
};

export const pendingApprovalAfterActions = (userInfo, jwtToken) => {
    return apiRequest(
        listOfUrls.pendingApprovalAfterActions(userInfo),
        jwtToken
    )
        .then(response => {
            const pendingApprovalAfterActions = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.id,
                    links: item.links[0].self,
                    name: item.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.endDate)
                        .add(7, 'days')
                        .format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(pendingApprovalAfterActions);
        })
        .catch(err => Promise.reject(err));
};

export const returnedForEditEvents = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.returnedForEditEvents(userInfo), jwtToken)
        .then(response => {
            const returnedForEditEvents = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.Event.id,
                    links: item.Event.links[0].self,
                    name: item.Event.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.dueDate).format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(returnedForEditEvents);
        })
        .catch(err => Promise.reject(err));
};

export const returnedForEditAfterActions = (userInfo, jwtToken) => {
    return apiRequest(
        listOfUrls.returnedForEditAfterActions(userInfo),
        jwtToken
    )
        .then(response => {
            const returnedForEditAfterActions = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.EventReport.Event.id,
                    links: item.EventReport.Event.links[0].self,
                    name: item.EventReport.Event.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.dueDate).format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(returnedForEditAfterActions);
        })
        .catch(err => Promise.reject(err));
};

export const rejectedEvents = (userInfo, jwtToken) => {
    return apiRequest(listOfUrls.rejectedEvents(userInfo), jwtToken)
        .then(response => {
            const rejectedEvents = response.data.map(item => {
                return {
                    createdAt: item.createdAt,
                    id: item.id,
                    links: item.links[0].self,
                    name: item.name,
                    updatedAt: item.updatedAt,
                    dueDate: moment(item.dueDate).format('YYYY-MM-DD')
                };
            });
            return Promise.resolve(rejectedEvents);
        })
        .catch(err => Promise.reject(err));
};

export const fetchAllAlerts = () => (dispatch, getState) => {
    const userInfo = getState().data.userInfo;
    const jwtToken = getState().auth.jwtToken;

    dispatch(alertsLoading());
    return Promise.all([
        pastDueNeedsReviewEvents(userInfo, jwtToken),
        pastDueNeedsReviewAfterActions(userInfo, jwtToken),
        pastDueReturnedForEditEvents(userInfo, jwtToken),
        pastDueReturnedForEditAfterActions(userInfo, jwtToken),
        pastDueIncompleteAfterAction(userInfo, jwtToken),
        incompleteEvents(userInfo, jwtToken),
        incompleteAfterActions(userInfo, jwtToken),
        incompleteAssignedAfterActions(userInfo, jwtToken),
        needsReviewEvents(userInfo, jwtToken),
        needsReviewAfterActions(userInfo, jwtToken),
        pendingApprovalEvents(userInfo, jwtToken),
        pendingApprovalAfterActions(userInfo, jwtToken),
        returnedForEditEvents(userInfo, jwtToken),
        returnedForEditAfterActions(userInfo, jwtToken),
        rejectedEvents(userInfo, jwtToken)
    ])
        .then(values => {
            dispatch(pastDueSuccess(values[0], 'needsReviewEvents'));
            dispatch(pastDueSuccess(values[1], 'needsReviewAfterActions'));
            dispatch(pastDueSuccess(values[2], 'returnedForEditEvents'));
            dispatch(pastDueSuccess(values[3], 'returnedForEditAfterActions'));
            dispatch(pastDueSuccess(values[4], 'incompleteAfterActions'));
            dispatch(incompleteSuccess(values[5], 'events'));
            dispatch(incompleteSuccess(values[6], 'afterActions'));
            dispatch(incompleteSuccess(values[7], 'assignedAfterActions'));
            dispatch(needsReviewSuccess(values[8], 'events'));
            dispatch(needsReviewSuccess(values[9], 'afterActions'));
            dispatch(pendingApprovalSuccess(values[10], 'events'));
            dispatch(pendingApprovalSuccess(values[11], 'afterActions'));
            dispatch(returnedForEditSuccess(values[12], 'events'));
            dispatch(returnedForEditSuccess(values[13], 'afterActions'));
            dispatch(rejectedEventsSuccess(values[14]));
            dispatch(alertsLoading());
        })
        .catch(err => {
            console.log(err);
            dispatch(alertsLoading());
            return Promise.reject(err);
        });
};

export const alertsLoading = () => ({
    type: types.ALERTS_LOADING
});

export const pastDueSuccess = (payload, type) => ({
    type: types.PAST_DUE_SUCCESS,
    pastDue: {
        [type]: payload
    }
});

export const incompleteSuccess = (payload, type) => ({
    type: types.INCOMPLETE_SUCCESS,
    incomplete: {
        [type]: payload
    }
});

export const needsReviewSuccess = (payload, type) => ({
    type: types.NEEDS_REVIEW_SUCCESS,
    needsReview: {
        [type]: payload
    }
});

export const pendingApprovalSuccess = (payload, type) => ({
    type: types.PENDING_APPROVAL_SUCCESS,
    pendingApproval: {
        [type]: payload
    }
});

export const returnedForEditSuccess = (payload, type) => ({
    type: types.RETURNED_FOR_EDIT_SUCCESS,
    returnedForEdit: {
        [type]: payload
    }
});

export const rejectedEventsSuccess = payload => ({
    type: types.REJECTED_EVENTS_SUCCESS,
    payload
});

export const setNewTasksVisited = () => ({
    type: types.SET_NEW_TASKS_VISITED
});



// WEBPACK FOOTER //
// ./src/actions/alerts.js